import { Injectable } from '@angular/core';
import { BackendService } from '../backend/backend.service';

@Injectable({
  providedIn: 'root'
})
export class UploadTestTimingService {

  private path = '/test-timings';

  constructor(
    private backendService: BackendService
  ) { }



  getBatches() {
    return this.backendService.get(this.path);
  }

  saveTestTiming(uploadtesttimingdata) {
    return this.backendService.post(this.path + '/import', uploadtesttimingdata);
  }

  searchUploadTestTimeDetail(currPage: number, pageSize: number, filter: any) {

    var data = {
      pagination: {
        page: currPage,
        size: pageSize
      },
      filter: filter
    };

    return this.backendService.post(this.path + "/search", data);

  }

  saveTestTimingdetails(testtiming) {
    return this.backendService.post(this.path + '/', testtiming);
  }
  

  getTestTimingByBatch(batch) {
    return this.backendService.get(this.path + "/batches/" + batch);
  }

  getTestTimingById(id) {
    return this.backendService.get(this.path + "/" + id);
  }

  deleteTestTimingById(id){
    return this.backendService.post(this.path + '/delete/' + id, {});
  }

  deleteAll(examCenter) {
    return this.backendService.post(this.path + "/delete", examCenter);
  }
}